import { render } from "./AppBranding.vue?vue&type=template&id=76b48f5b"
import script from "./AppBranding.vue?vue&type=script&lang=js"
export * from "./AppBranding.vue?vue&type=script&lang=js"

import "./AppBranding.vue?vue&type=style&index=0&id=76b48f5b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__